import { createSelector } from 'reselect';

const auth = state => state.auth;

export const getStep = createSelector(auth, state => state.createWalletStep);
export const getLw = createSelector(auth, state => state.lwService);
